// @ts-nocheck
import { useState, useEffect } from 'react';
import { Box, Modal, Button, Typography } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import useAuth from '../hooks/useAuth';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90vw', sm: 600 },
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: { xs: 2.5, sm: 4 },
};

export default function LoginNoticeModal() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (user && user.id) {
      const hideLoginModal = localStorage.getItem('hideLoginModal');
      const loginModalShown = localStorage.getItem('loginModalShown');
      if (loginModalShown != 1) {
        if (!hideLoginModal || hideLoginModal == 0) {
          setChecked(true);
          setOpen(true);
          localStorage.setItem('loginModalShown', 1);
        }
      }
    }
  }, [user]);

  const handleCheckbox = (e) => {
    setChecked(e.target.checked);
    localStorage.setItem('hideLoginModal', e.target.checked ? 0 : 1);
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="login-notice-title"
      aria-describedby="login-notice-description"
    >
      <Box sx={modalStyle}>
        <Typography id="login-notice-title" variant="h6" component="h2">
          Important Notice!
        </Typography>

        <Typography sx={{ my: 2 }}>
          WeSafe will add tasks to your to do list whenever there is something to be done. If you ignore your to do list WeSafe will send you reminder SMS’s and Emails every 2 days until the task has been complete. Please complete all tasks as they are added.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'flex-end', alignItems: { xs: 'stretch', sm: 'center' }, gap: 1 }}>
          <FormGroup>
            <FormControlLabel control={<Checkbox onChange={handleCheckbox} checked={checked} />} label="Open every time on login" />
          </FormGroup>
          <Button sx={{ ml: 2 }} variant="contained" onClick={() => setOpen(false)} type="button" color="primary">
            I Understand
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
